const Viewports = {
  Mobile: "mobile",
  Tablet: "tablet",
  Laptop: "laptop",
  Desktop: "desktop",
};

export { Viewports };
